module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_16.9591adb1.png";